import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import Navbar from '../components/shared/Navbar';
import SEO from '../components/SEO';
import AppStoreBadges from '../components/AppStoreBadges';
import { isNative } from '../utils/capacitor';
import { APP_STORE_URL, playStoreUrl, deviceStore, isBot } from '../utils/appLinks';
import { trackAppStoreClick } from '../utils/analytics';

// dreamybedtime.com/app — one link to share anywhere. A phone goes straight to
// its own store; a computer (or a search-engine crawler, which is never
// redirected) gets both badges.
const AppDownloadPage = () => {
  const store = !isNative() && !isBot() ? deviceStore() : null;

  useEffect(() => {
    if (!store) return;
    trackAppStoreClick(store === 'ios' ? 'app_store' : 'google_play', 'app_link');
    window.location.replace(store === 'ios' ? APP_STORE_URL : playStoreUrl('app_link'));
  }, [store]);

  // Opened inside the app itself: they already have it.
  if (isNative()) return <Navigate to="/" replace />;

  return (
    <div style={{ background: 'var(--page-bg)', minHeight: '100vh' }}>
      <SEO
        title="Get the Dreamy Bedtime App for iPhone, iPad and Android"
        description="Download Dreamy Bedtime on the App Store or Google Play. Personalized bedtime stories starring your child, with illustrations and narration."
      />
      <Navbar />
      <div className="container text-center" style={{ maxWidth: '640px', padding: '72px 16px' }}>
        <div style={{ fontSize: '56px' }}>🌙</div>
        <h1 className="fw-bold mb-3" style={{ fontFamily: "'Fredoka One',cursive", color: 'var(--text-main)', fontSize: 'clamp(28px,5vw,40px)' }}>
          Get the Dreamy Bedtime app
        </h1>
        <p className="mb-4" style={{ color: 'var(--text-muted2)', fontSize: '17px', lineHeight: 1.7 }}>
          {store
            ? `Opening ${store === 'ios' ? 'the App Store' : 'Google Play'}…`
            : 'Personalized bedtime stories starring your child, on iPhone, iPad and Android. Sign in with the same account you use here and your stories and plan come with you.'}
        </p>
        <AppStoreBadges placement="app_page" height={52} justify="center" />
      </div>
    </div>
  );
};

export default AppDownloadPage;
